import { SelectedAddon } from '@/app/[locale]/[ferry]/extras/_components/interface'

export const toAddonResource = (parentAddonCode: string, addonCode: string, typeCode: string): string => {
  return `${parentAddonCode.toUpperCase()}-${addonCode.toUpperCase()}-${typeCode.toUpperCase()}`
}

export const filterAddons = (previousAddons: SelectedAddon[], addon: SelectedAddon): SelectedAddon[] => {
  const newAddonList: SelectedAddon[] = previousAddons.filter(
    (a) => a.parentAddonCode !== addon.parentAddonCode || a.addonCode !== addon.addonCode || a.addonType !== addon.addonType
  )
  return addon.selectedQuantity === 0 ? newAddonList : newAddonList.concat([addon])
}
